import { Box, Stack, Typography, LinearProgress } from '@mui/material';
import category from "../assets/category.png";
import { NavLink } from 'react-router-dom'; // Corrected the import path
import { FavoriteBorder } from '@mui/icons-material';

function Category() {
    return (
        <Stack sx={{ border: '1px solid #eee', borderRadius: "12px", padding: "10px", alignItems: "center", textAlign: "right", width: '340px' }} >
            {/* Image Container */}
            <Box sx={{ borderRadius: "12px", overflow: 'hidden', width: '100%', height: '200px', position: 'relative' }}>
                <img
                    src={category}
                    alt="category"
                    style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover', // Ensures image scales without distortion
                    }}
                />
            </Box>

            {/* Text and Content */}
            <Stack alignItems={"end"} sx={{ width: '100%' }}>
                <Stack direction={"row"} gap={2} alignItems={"center"} justifyContent={"start"} sx={{ mb: 2 }}>
                    <Typography className={'CategorText'} >
                        إعادة بناء جزئية
                    </Typography>
                    <Typography className={'CategorText'} >
                        دعم كامل
                    </Typography>
                    <Typography sx={{ color: "#15513c" }} >
                        4,شباط,2025
                    </Typography>
                </Stack>
                <Typography variant='h6' sx={{ textAlign: "right", fontWeight: "bold", mt: 1 }}>منزل اسرة مؤلفة من 8 افراد متضرر من الزالزال</Typography>
                <Typography variant='body1' sx={{ textAlign: "right", fontWeight: "bold", mt: 1, color: "#777" }}>
                    ....منزل متضرر من الزلزال 2023 يحتاج الى تدعيم
                </Typography>

                {/* Progress bar and financial info */}
                <Box sx={{ width: '100%', mt: 2 }}>
                    <LinearProgress value={10} variant='determinate' color="success" />
                    <Stack direction={"row"} gap={2} alignItems={"center"} justifyContent={"space-between"} sx={{ mt: 1 }}>
                        <Typography>100.000.000 ل.س</Typography>
                        <Typography>100.000 ل.س</Typography>
                    </Stack>
                </Box>
            </Stack>

            {/* Donation Button */}
            <NavLink className="btnLink" style={{ width: '80%' }}>
                <FavoriteBorder sx={{ mt: 1, mr: 1 }} />
                تبرع الأن
            </NavLink>
        </Stack>
    );
}

export default Category;
